<template>
  <button
    :class="[
      'leading-[1.375rem] tracking-[-.016em] p-2 rounded-sm w-auto inline-flex items-center justify-between',
      !secondaryButton &&
        !textButton &&
        'text-white bg-hqPurple hover:bg-hoverPrimaryButton focus:bg-focusPrimaryButton',
      secondaryButton &&
        'text-hqPurple outline-hqPurple100 outline-solid -outline-offset-1 outline-1',
      textButton &&
        'border-0 hover:outline-solid outline-solid outline-hqPurple100 outline-1 -outline-offset-1',
      fullWidth && 'w-full justify-center!',
      disabled &&
        'disabled:bg-gray-400 disabled:outline-0 disabled:cursor-not-allowed disabled:text-white',
      classes && classes,
    ]"
    :disabled="disabled"
    :title="title"
    tabindex="0"
    type="button"
    v-bind="$attrs"
  >
    <Icon
      v-if="leftIcon"
      :color="leftIconColor"
      :icon="leftIcon"
      :size="leftIconSize"
      :viewBox="leftIconViewBox"
    />
    <Text v-if="text" class="flex px-2">{{ text }}</Text>
    <slot />
    <Icon
      v-if="rigthIcon"
      :color="rightIconColor"
      :icon="rigthIcon"
      :size="rightIconSize"
      :viewBox="rightIconViewBox"
    />
  </button>
</template>

<script setup>
import Icon from "../../Iconography/Icon/Icon.vue";
import Text from "../../Typography/Text.vue";

defineProps({
  text: String,
  secondaryButton: Boolean,
  rigthIcon: String,
  leftIcon: String,
  fullWidth: Boolean,
  disabled: Boolean,
  textButton: Boolean,
  leftIconSize: {
    type: String,
    default: "20",
  },
  rightIconSize: {
    type: String,
    default: "20",
  },
  leftIconColor: String,
  rightIconColor: String,
  leftIconViewBox: {
    type: String,
    default: "0 0 24 24",
  },
  rightIconViewBox: {
    type: String,
    default: "0 0 24 24",
  },
  classes: String,
  title: String,
});
</script>

<style></style>
